/* eslint-disable react/no-unknown-property */
import React from 'react';
import { IconsPropsType } from './icons.config.type';

const SameOut: React.FC<IconsPropsType> = ({ style, color, onClick, className }) => {
  return (
    <svg
      style={{ ...style }}
      width="33"
      height="30"
      viewBox="0 0 33 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="19" height="29" rx="2.5" stroke="black" />
      <path
        d="M32.0531 15L22.3308 9V12.3267L7.05305 12.3333L7.05305 17.6667H22.3308V21L32.0531 15Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    // </div>
  );
};

SameOut.defaultProps = {
  style: { width: '33', height: '30px' },
  color: '#fff',
  onClick: undefined,
  className: undefined,
};

export default SameOut;
